import { useLocation } from 'react-router-dom';
import { PDFViewer } from '@react-pdf/renderer';
import QCClientPDF from './QC-ClientPDF'

function QCClientPDFview() {
  const location = useLocation();
  const quotation = location.state?.e;
  const userDetails1 = location.state?.userDetailsLo;

  return (
    <PDFViewer  width="100%" height="950">
      <QCClientPDF e={quotation} userDetails1={userDetails1}/>
    </PDFViewer>
  );
}

export default QCClientPDFview;
